export const enum UserFrontendLoginProvidersEnum {
  google = 'Google',
  googleOneTap = 'google_one_tap',
  facebook = 'Facebook',
  email = 'Email',
  PHONE_NUMBER = 'phone_number',
}
